const state = {
    generalComment: Object,
    submitSuccess: false 
}

const getters = {
    //
}

const mutations = {
    setGeneralComment (state, data) {
        return state.generalComment = data
    },
    setGeneralCommentElement (state, data) {
        return state.generalComment = { ...state.generalComment, [data.id]: data.value }
    },
    setSubmitSuccess(state, data) {
        return state.submitSuccess = data
    }
}

const actions = {
    setGeneralCommentElement (context, data) {
        context.commit("setGeneralCommentElement", data)
    },
    fetchGeneralComment (context, data) {
        axios.get('/api/general-comment', {params: data})
        .then( (response) => {
            context.commit("setGeneralComment", response.data)
        })
        .catch( (e) => {
            console.log("Error: general_comment.js, fetchGeneralComment(), "+ e.message)          
        })
    },
    saveGeneralComment (context, data) {
        axios.post('/api/general-comment', data)
        .then( (response) => {
            context.commit("setSubmitSuccess", true)
            context.commit("setGeneralComment", response.data)   
        })
        .catch( (e) => {
            context.commit("setSubmitSuccess", false)
            console.log("Error: general_comment.js, saveGeneralComment(), "+ e.message)
        })
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}